export { Table } from './table';
export { TableRow } from './table-row';
export { TableHeadCell } from './table-head-cell';
export { TableCell } from './table-cell';

export type { TableTotalProps, TableCellType } from './table';
